export enum SubNavigationLinkType {
  action = 'action',
  route = 'route',
  component = 'component',
  empty = 'empty',
  navlink = 'navlink',
  separator = 'separator',
}
